import { useSSRContext } from "vue";
export class ServerHistoryState {
    constructor(app, options) {
        this.options = options;
        this._action = "navigate";
        this._initialized = false;
        const router = app.config.globalProperties.$router;
        if (router == null) {
            throw new Error("Vue Router is needed.");
        }
        router.afterEach((to, from, failure) => {
            this._initialized = false;
            if (this.options.debug) {
                this._debug("afterEach");
            }
        });
        app.mixin({
            beforeCreate: () => {
                if (!this._initialized) {
                    const ssrContext = useSSRContext();
                    if (!ssrContext) {
                        throw new Error("SSRContext is not found");
                    }
                    if (ssrContext.req && ssrContext.req.headers) {
                        const cacheControl = ssrContext.req.headers["cache-control"] || ssrContext.req.headers["pragma"];
                        if (/^(no-cache|max-age=0)$/.test(cacheControl)) {
                            this._action = "reload";
                        }
                    }
                    this._initialized = true;
                    if (this.options.debug) {
                        this._debug("beforeCreate");
                    }
                }
            },
        });
    }
    get action() {
        return this._action;
    }
    get visited() {
        return this._action === "reload";
    }
    get page() {
        return 0;
    }
    get data() {
        return undefined;
    }
    set data(value) {
        throw new Error("data is not supported on server.");
    }
    get info() {
        return undefined;
    }
    get canGoBack() {
        throw new Error("canGoBack is not supported on server.");
    }
    get canGoForward() {
        throw new Error("canGoForward is not supported on server.");
    }
    get length() {
        throw new Error("length is not supported on server.");
    }
    getItem(page) {
        throw new Error("getItem is not supported on server.");
    }
    getItems() {
        throw new Error("getItems is not supported on server.");
    }
    clearItemData(page) {
        throw new Error("clearItemData is not supported on server.");
    }
    findBackPage(location) {
        throw new Error("findBackPosition is not supported on server.");
    }
    push(url, info) {
        throw new Error("push is not supported on server.");
    }
    reload(info) {
        throw new Error("reload is not supported on server.");
    }
    back(info) {
        throw new Error("back is not supported on server.");
    }
    forward(info) {
        throw new Error("forward is not supported on server.");
    }
    goToPage(page, info) {
        throw new Error("goToPage is not supported on server.");
    }
    _debug(marker) {
        console.log(`[${marker}] _page: ${this.page}, _action: ${JSON.stringify(this._action)}`);
    }
}
//# sourceMappingURL=history_state.server.js.map